import { useEffect, useState } from "react";
import { Plus, RefreshCw, UtensilsCrossed } from "lucide-react";
import { api, money, USER_ID, track } from "../api";
import { addPick } from "../picks";

export const FoodRec = ({ source }) => {
  const [rec, setRec] = useState(null);
  const [excluded, setExcluded] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = (ex) => {
    setBusy(true);
    api.get("/arcade/food-rec", { params: { user_id: USER_ID, exclude: ex.join(",") } })
      .then((r) => { setRec(r.data); track("arcade_food_rec_shown", { slug: r.data.dish.slug, source }); })
      .catch(() => {})
      .finally(() => setBusy(false));
  };
  useEffect(() => { load([]); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!rec) return null;
  const { dish, pairing } = rec;

  const replace = () => {
    const ex = [...excluded, dish.slug];
    setExcluded(ex);
    load(ex);
  };

  return (
    <div data-testid="food-rec-card" className="mt-4 rounded-2xl border border-[#D4AF37]/35 bg-[#17110A] overflow-hidden">
      <p className="px-4 pt-3 text-[9px] tracking-[0.3em] text-[#D4AF37] font-black">HUNGRY AFTER THE GAME? TRY THIS</p>
      <div className="flex gap-3 p-4 pt-2">
        {dish.image ? <img src={dish.image} alt={dish.name} className="w-20 h-20 rounded-xl object-cover shrink-0" />
          : <span className="w-20 h-20 rounded-xl bg-[#1A1A1A] flex items-center justify-center text-[#D4AF37]/40 shrink-0"><UtensilsCrossed size={20} /></span>}
        <div className="min-w-0 flex-1">
          <p data-testid="food-rec-name" className="text-sm font-bold leading-snug">{dish.name}</p>
          <p className="text-xs text-white/55 leading-snug mt-0.5 line-clamp-2">{dish.description}</p>
          <p className="text-sm font-black text-[#D4AF37] mt-1">{money(dish.price)}</p>
        </div>
      </div>
      {pairing && (
        <div data-testid="food-rec-pairing" className="mx-4 mb-3 rounded-xl border border-[#E25822]/30 bg-[#1C1006] p-2.5 flex items-center gap-2.5">
          {pairing.image && <img src={pairing.image} alt={pairing.name} className="w-10 h-10 rounded-lg object-cover shrink-0" />}
          <div className="min-w-0 flex-1">
            <p className="text-[8px] tracking-[0.25em] text-[#E25822] font-black">PAIRS PERFECTLY WITH</p>
            <p className="text-xs font-bold truncate">{pairing.name} · {money(pairing.price)}</p>
          </div>
          <button data-testid="food-rec-add-pairing" onClick={() => addPick(pairing)}
            className="shrink-0 w-8 h-8 rounded-full bg-[#E25822] text-white flex items-center justify-center"><Plus size={14} /></button>
        </div>
      )}
      <div className="flex gap-2 px-4 pb-4">
        <button data-testid="food-rec-add" onClick={() => { addPick(dish); track("arcade_food_rec_added", { slug: dish.slug, source }); }}
          className="flex-1 h-10 rounded-full bg-[#D4AF37] text-black text-[10px] font-black tracking-widest">ADD TO ORDER</button>
        <button data-testid="food-rec-replace" onClick={replace} disabled={busy}
          className="flex items-center gap-1.5 h-10 px-4 rounded-full border border-white/20 text-white/60 text-[10px] font-bold tracking-widest disabled:opacity-50">
          <RefreshCw size={11} className={busy ? "animate-spin" : ""} /> ANOTHER
        </button>
      </div>
    </div>
  );
};
